<template>
  <div class='sidebar'>
    <div class="logo">
      <!--
      <img src="https://aquilafly-product.oss-cn-shenzhen.aliyuncs.com/B0/adminLayout/Logo.png" alt="">
      -->
    </div>
    <div class="brand">
      <img src="https://aquilafly-product.oss-cn-shenzhen.aliyuncs.com/B0/adminLayout/bjlLogo.png" alt="">
    </div>
    <div class="title">北京路步行街</div>
    <div class="list">
      <el-menu
        :default-active="id"
        :unique-opened='true'
        text-color='#A3B5D8'
        active-text-color='#1764E8'
        class="el-menu">
          <div v-for="item in TreeList" :key="item.id">
            <el-menu-item :index="item.id" v-if="item.children.length === 0" @click="select(item)">
              <i v-if="item.icon" :class="item.icon"></i>
              <span slot="title">{{item.name}}</span>
            </el-menu-item>
            <el-submenu :index="item.id" v-else>
              <template slot="title">
                <i v-if="item.icon" :class="item.icon"></i>
                <span>{{item.name}}</span>
              </template>
              <el-menu-item :index="item2.id" v-for="item2 in item.children" :key="item2.id" @click="select(item2)">{{item2.name}}</el-menu-item>
            </el-submenu>
          </div>
        </el-menu>
    </div>
  </div>
</template>

<script>
import api from '@/shared/api/apps'
export default {
  name: 'sidebar',

  data () {
    return {
      id: '',
      TreeList: [],
      tenantId: JSON.parse(sessionStorage.getItem('User')).tenantId
    }
  },

  mounted () {
    this.init()
  },

  methods: {
    init () {
      this.getTreeList()
    },

    getTreeList () {
      const params = {
        method: api.afterLogin,
        product: 4,
        device: 1
      }
      this.axios.post(params).then(res => {
        if (res.data.backend_org_ums_permission_listMenuTree_afterLogin_response.code !== '10000') return
        this.TreeList = res.data.backend_org_ums_permission_listMenuTree_afterLogin_response.items
        if (this.TreeList.length < 0) return
        if (this.TreeList[0].children.length > 0) {
          this.setMenuName(this.TreeList)
        } else {
          this.id = this.TreeList[0].id
          this.$emit('SetData', this.TreeList[0])
        }
      })
    },

    setMenuName (children) {
      children.forEach(res => {
        if (res.uri === this.$route.name) {
          this.id = res.id
          this.$emit('SetData', res)
          return
        }
        if (res.children.length > 0) {
          this.setMenuName(res.children)
        }
      })
    },

    select (val) {
      this.$emit('SetData', val)
      this.$router.push({ name: val.uri })
    }
  }
}
</script>

<style lang='stylus' scoped>
  .sidebar
    display flex
    flex-direction column
    align-items center
    width 220px
    background #ffffff
    .logo
      width 180px
      height 70px
      display flex
      justify-content center
      align-items center
      border-bottom 2px solid #DBE3EF
      img
        width 116px
    .brand
      margin-top 40px
      img
        width 86px
    .title
      margin-top 25px
      width 160px
      height 30px
      line-height 30px
      display flex
      justify-content center
      align-items center
      background #E7FAF6
      border-radius 15px
      font-size 16px
      font-weight bold
      color #20B690
      letter-spacing 2px
    .list
      margin 30px 0 20px
      width 100%
      flex auto
      overflow hidden
      .el-menu
        border none
        .menu
          display flex
          .icon
            width 20px
            height 20px
            margin-right 5px
            vertical-align middle
            img
              width 100%
</style>
